import React, { useEffect, useState } from 'react'

import FuelTokens from '../../../../components/Project/Resources/FuelTokens/FuelTokens'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { FuelTokensApi, remove as removeApi } from '../../../../api/Projects/Resources'
import useSelectionTable from '../../../../elements/Hooks/useSelectionTable'
import useModalData from '../../../../elements/Hooks/useModalData'
import { message } from 'antd'

function FuelTokensCont(props) {
  const { project } = props
  const { list, fetching, fetch } = useFetchList(() => FuelTokensApi.list(project._id, 'fuelTokens'))
  const { tableRef, selection, selectAll, setSelection, toggleSelection, toggleAll, isSelected } = useSelectionTable()

  const {
    visible,
    modalType,
    object: fuelToken,
    submitting,
    setSubmitting,
    formRef,
    onShow,
    onCancel,
    checkForm,
    update,
    removing,
    remove,
  } = useModalData(FuelTokensApi.create, FuelTokensApi.update, removeApi, fetch)

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await FuelTokensApi.create({ ...newObject, project })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <FuelTokens
      {...{
        project,
        list,
        fetching,
        submitting,
        visible,
        fetch,
        fuelToken,
        onShow,
        onCancel,
        checkForm,
        submit,
        update,
        modalType,
        formRef,
        removing,
        remove,
        //selection
        selection,
        selectAll,
        setSelection,
        tableRef,
        toggleSelection,
        toggleAll,
        isSelected,
      }}
    />
  )
}

FuelTokensCont.propTypes = {}
FuelTokensCont.defaultProps = {}

export default (FuelTokensCont)
